import React from 'react';
import { Draggable } from "react-beautiful-dnd";
import { Card } from "react-bootstrap";
import { useDispatch } from 'react-redux';
import { removeScoutMember } from '../../../actions/scout-kanban';

const getItemStyle = (draggableStyle) => ({
    userSelect: 'none',
    ...draggableStyle,
});

const SGCard = (props) => {
    const dispatch = useDispatch();
    const { smId, scoutGroupId, index, sgItem, onFilter } = props;

    const removeScout = (sgData) => {
        dispatch(removeScoutMember(sgData));
    }

    if (!sgItem || !onFilter(sgItem)) return <></>;

    return <Draggable draggableId={`${scoutGroupId}_${smId}`} index={index} /* isDragDisabled={!isAllowEdit} */>
        {(provided, snapshot) => (
            <div ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                style={getItemStyle(provided.draggableProps.style)}>

                <Card className={`kanban-card scout_card_details ${snapshot.isDragging ? "dragging" : ""}`}>
                    <Card.Body>
                        <div className="card-caption d-flex flex-row justify-content-between">
                            <div className="card-title-wrap">
                                <div className='scouts_icons'>
                                    <i className={`img-type ${sgItem.scout_type_id === 17 ? 'fa fa-user' : 'icon icon-map-shape'}`} aria-hidden="true"></i>
                                </div>
                                <Card.Title className="text-muted" title={sgItem.scout_member_name}>
                                    {sgItem.scout_member_name}
                                </Card.Title>
                            </div>
                            <div className="unassign-btn scout_unassign_btn">
                                {<i className="fa fa-times" aria-hidden="true" title="Leave Field" onClick={(() => removeScout({ scoutGroupId, smId }))} />}
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        )}

    </Draggable>
}

export default SGCard;